import { Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import parse from "html-react-parser";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

function TipComponent({
  classes,
  history,
  tip,
  dietPlan,
  style,
  hydrationStatus,
  suggestedQuantity,
  competencyBasedTips,
  handleDownloadDietPlan,
  perDayViewData,
}) {
  const textColor =
    (hydrationStatus && hydrationStatus.toLowerCase()) === "under hydrated"
      ? "red"
      : (hydrationStatus && hydrationStatus.toLowerCase()) ===
        "adequately hydrated"
      ? "green"
      : "black";

  const displayedStatus =
    (hydrationStatus && hydrationStatus.toLowerCase()) === "under hydrated"
      ? `${hydrationStatus}!`
      : hydrationStatus;

  let displaySuggestedQuantity = suggestedQuantity;

  if (suggestedQuantity && typeof suggestedQuantity === "string") {
    let splittedParts = suggestedQuantity.split(" ");
    if (splittedParts.length === 2 && splittedParts[1] === "Glass") {
      let quantity = parseFloat(splittedParts[0]);
      let roundedQuantity = Math.round(quantity);
      displaySuggestedQuantity = roundedQuantity + " " + splittedParts[1];
    }
  }

  let data = [];
  // parsing the tip and making array for show more and show less.
  const parser = new DOMParser();
  const doc = parser.parseFromString(tip, "text/html");
  const decodedString = doc.body.innerHTML;
  const sequence = "&amp;&amp;&amp;&amp;&amp;";

  if (decodedString.includes(sequence)) {
    data = decodedString.split(sequence);
  } else {
    data = [decodedString];
  }

  const hasTip = tip && data.length > 0 && data[0].trim() !== "";
  const hasDiet =
    dietPlan && (dietPlan.breakfast || dietPlan.lunch || dietPlan.dinner);
  const hasHydration = hydrationStatus || suggestedQuantity;
  const hasCompetencyBasedTips =
    competencyBasedTips && competencyBasedTips.length > 0;

  return (
    <div className={classes.container} style={style}>
      {hasTip ? (
        <div className="tipSection">
          <span className={"title"}>{"Tip of the day"}:</span>
          &nbsp;
          <ListComponent list={data || []} />
        </div>
      ) : hasDiet ? (
        <div className="dietSection">
          <span className={"title"}>{"Diet Plan"}</span>
          &nbsp;
          {dietPlan?.breakfast && (
            <p>
              <strong>Breakfast:</strong> {dietPlan.breakfast}
            </p>
          )}
          {dietPlan?.lunch && (
            <p>
              <strong>Lunch:</strong> {dietPlan.lunch}
            </p>
          )}
          {dietPlan?.dinner && (
            <p>
              <strong>Dinner:</strong> {dietPlan.dinner}
            </p>
          )}
          {perDayViewData?.programChallengeType === "NO_UNHEALTHY_EATING" && (
            <>
              <p className={classes.noteStyle}>
                <strong>
                  Note: Cafeteria (Canteen) users are welcome to continue.
                  Others may follow Recommended Diet Plan
                </strong>
                .
              </p>
              <p className={classes.noteStyle}>
                Plan your week in advance:
                <a
                  onClick={() => {
                    handleDownloadDietPlan();
                  }}
                  style={{ marginLeft: "5px" }}
                >
                  Click here to download diet plan.
                </a>
              </p>
            </>
          )}
        </div>
      ) : hasHydration ? (
        <p style={{ color: "black" }}>
          <span className={"title"}>{"Hydration Status"}:</span>
          &nbsp;
          <span className="textValueHydration" style={{ color: textColor }}>
            {" "}
            {displayedStatus}
          </span>
          {suggestedQuantity && (
            <p>
              <span className={"title"}>Suggested Quantity:</span>
              &nbsp;
              <span className="textValueHydration">
                {displaySuggestedQuantity}
              </span>
            </p>
          )}
        </p>
      ) : hasCompetencyBasedTips ? (
        <div className="compencyBasedTipsSection">
          <span className={"title"}>Activity Tip:</span> &nbsp;
          {competencyBasedTips && competencyBasedTips.length > 0
            ? competencyBasedTips
            : "No tips available"}
        </div>
      ) : null}
    </div>
  );
}

const styles = (theme) => ({
  container: {
    borderRadius: "10px",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    // background: "linear-gradient(to right, #fdf5ee, #f2b888)",
    padding: "10px",
    "& .title": {
      fontWeight: 600,
      fontSize: "22px",
      minWidth: "fit-content",
      [theme.breakpoints.down("sm")]: {
        fontSize: "17px",
      },
    },

    "& .textValue": {
      textTransform: "capitalize",
    },
    "& .textValueHydration": {
      textTransform: "capitalize",
      fontWeight: "bold",
      fontSize: "18px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },
    "& .tipSection": {
      color: "black",
      display: "flex",
      alignItems: "baseline",
      gap: "5px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        gap: "0px",
      },
    },
    "& .dietSection": {
      color: "black",
      display: "flex",
      flexDirection: "column", // stack items vertically
      alignItems: "flex-start", // optional: aligns items to the start
      [theme.breakpoints.down("xs")]: {
        gap: "0px",
      },
    },
    "& .dietSection p": {
      margin: "4px 0", // reduce margin between lines
    },
  },
  noteStyle: {
    fontStyle: "italic",
    fontSize: "14px",
  },
});

export default compose(withStyles(styles), withRouter)(TipComponent);

function ListComponent({ list }) {
  const [show, setShow] = useState(false);

  return (
    <div>
      {list?.length > 0 ? (
        <>
          <span
            className="listItem-tip"
            style={{
              "& > p": {
                margin: "-12px 0",
              },
            }}
          >
            {parse(`${list[0]}`)}
          </span>
          {show && (
            <span>
              {list.slice(1).map((item, index) => (
                <span style={{ display: "block" }}>
                  {parse(`${item}${index === list.length - 2 ? "" : ","}`)}
                </span>
              ))}
            </span>
          )}
          {list.length > 1 && (
            <span
              onClick={() => setShow(!show)}
              style={{
                cursor: "pointer",
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#3788d8",
                padding: "5px",
                // background:"#d7e7f7",
                width: "fit-content",
                display: "flex",
                alignItems: "center",
                // textDecoration: "underline",
              }}
            >
              Show {show ? "less" : "more"}{" "}
              {show ? <ExpandLess /> : <ExpandMore />}
            </span>
          )}
        </>
      ) : (
        <span>{"-"}</span>
      )}
    </div>
  );
}
